// Package imports:
import React, { useState } from "react";
// Component imports:
import Alert from "../../../ui-elements/Alert/Alert";
import LykilordForm from "./LykilordForm";

const Lykilord: React.FC = () => {
    const [contactResponse, setContactResponse] = useState<JSX.Element>();

    return (
        <div className="Lykilord">
            <div>
                {(contactResponse) &&
                    (
                        <div className="form__row">
                            <div className="form__col">
                                {contactResponse}
                            </div>
                        </div>
                    )
                }
            </div>
            <div className="section__body">
                <div className="left-section">
                    <h3>Endursetja lykilorð</h3>
                    <LykilordForm contactResponse={(response: JSX.Element) => setContactResponse(response) }/>
                    <p className="passwordDisclaimer">Athugaðu að nýtt lykilorð á við um eftirfarandi kerfi Kóða ehf.</p>

                    <div className="text__image">
                        <p>
                            <img
                                src="https://cdn.livemarketdata.com/Images/keldan_icon.svg"
                                alt="Keldan"
                                width="30"
                                height="30"
                            />
                            {" "}
                            Keldan og Keldan App
                        </p>
                        <p>
                            <img
                                src="https://cdn.livemarketdata.com/Images/kodiak_pro_icon.svg"
                                alt="Kodiak Pro"
                                width="30"
                                height="30"
                            />
                            {" "}
                            Kodiak Pro
                        </p>
                    </div>
                </div>
                <div className="right-section">
                    <Alert
                        type="info"
                        headText="Athugið"
                        text={<p>Lykilorð þarf að innihalda a.m.k. 12 stafi; einn tölustaf, einn hástaf, og einn lágstaf</p>}
                    />
                </div>
            </div>
        </div>
    )
}

export default Lykilord;